import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbDownFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M9.802 14.117c-.082 1.02-1.178 1.696-2.143 1.236-1.012-.482-1.363-1.475-1.363-2.582v-2.046H3.228C.905 10.653.24 9.768.585 7.32l.48-3.41C1.42 1.37 2.39.512 4.931.5h5.966v10.491h.083c-.69 1.028-1.087 2.004-1.179 3.126"
                    fill="currentColor"
                />
                <path
                    d="M12.298 10.04c2.39-.098 3.202-1.052 3.202-3.63V4.137c0-2.578-.812-3.531-3.203-3.628z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ThumbDownFilledSize16Glyph.displayName = 'ThumbDownFilledSize16Glyph';
